import React, { useEffect } from 'react'

import { FieldController, Input } from '@pb/components'
import { getLabelFromStorage } from '@pb/utils'
import { useFormContext } from 'react-hook-form'
import { useDispatch } from 'react-redux'

import {
  CHECKOUT_TRACKING_ERROR_TYPES,
  CHECKOUT_TRACKING_SECTIONS,
  FIELD_TYPES,
} from 'features/checkout/constants'
import { trackError } from 'features/checkout/duck/operations'
import { getFieldErrorMessage } from 'features/checkout/helpers/getFieldErrorMessage'
import { VOUCHERS_LOCATION } from 'features/vouchers/constants'

const AddDiscountInput: React.FC<any> = ({ onChangeDiscount = () => {}, ...props }) => {
  const isCheckout = props?.location === VOUCHERS_LOCATION.checkout
  const dispatch = useDispatch()
  const input = (
    <Input type="text" name="discountCode" shouldShowValidationIcon={false} {...props} />
  )
  const { errors, watch } = useFormContext()
  const discountCode = watch('discountCode')

  useEffect(() => onChangeDiscount(discountCode), [discountCode])

  useEffect(() => {
    if (isCheckout && !!errors?.discountCode) {
      const errorType =
        errors.discountCode?.type === 'error'
          ? FIELD_TYPES.backendError
          : errors?.discountCode?.type
      const errorFieldName = 'discountCode'
      dispatch(
        trackError({
          section: CHECKOUT_TRACKING_SECTIONS.general,
          message: getFieldErrorMessage({
            type: errorType,
            fieldConfigName: '',
            fieldName: errorFieldName,
          }),
          id: `${errorType}_${errorFieldName}`,
          errorType: CHECKOUT_TRACKING_ERROR_TYPES.field,
        }),
      )
    }
  }, [JSON.stringify(errors)])

  return (
    <FieldController
      as={input}
      name="discountCode"
      type="input"
      rules={{ required: getLabelFromStorage('checkout.discountcode.error') }}
    />
  )
}

export default AddDiscountInput
